<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;"><s-header-top></s-header-top></el-header>
			<el-header class="header"><s-header></s-header></el-header>
			<el-main>
				<div class="content">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<span style="float: left;">当前位置：</span>
						<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/product' }">服务产品</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/productDetail' }">详情</el-breadcrumb-item>
					</el-breadcrumb>

					<div class="page">
						<div class="page_body">
							<div class="detail_info mar_bottom">
								<div class="detail_info_image">
									<el-image style="width: 200px; height: 200px" :src="item.image?imgPath(item.image) : require('../../static/pro.jpg')" fit="contain"></el-image>
								</div>
								<div class="detail_info_mark">
									<el-row class="name mar_bottom">
										<el-col :span="24">{{ item.name ? item.name : '' }}</el-col>
									</el-row>
									<el-row class="company mar_bottom10">
										<el-image class="company_before_tag" :src="require('../../static/product_tag.png')" fit="contain"></el-image>
										<div class="company_name">{{ item.company ? item.company : '' }}</div>
									</el-row>
									<el-row class="price mar_bottom10">
										<el-col :span="24">￥{{ item.price ? item.price : '' }} 起</el-col>
									</el-row>
									<el-row class="buttons" type="flex">
										<div class="buy" @click="buy()">
											<i class="el-icon-shopping-cart-full"></i>
											订购
										</div>
										<div class="call" @click="call('咨询热线', item.telephone)">
											<i class="el-icon-chat-dot-round"></i>
											订购咨询
										</div>
										<div class="save" @click="save()" v-if="!isCollect">
											<i class="el-icon-star-off"></i>
											收藏
										</div>
										<div class="save" @click="cancelColl()" v-else>
											<i class="el-icon-star-on" style="color: #ffaa00;"></i>
											已收藏
										</div>
									</el-row>
								</div>
							</div>
							<el-row class="remark  mar_bottom">
								<el-col :span="24"  class="lab_hr"><div class="lab mar_bottom10">服务描述</div></el-col>
								<el-col :span="24"><p v-html="item.info"></p></el-col>
							</el-row>
						</div>
					</div>
					<!-- 输入金额dialog -->
					<el-dialog title="请输入金额" :visible.sync="outerVisible">
						<!-- 二维码dialog -->
						<el-dialog title="扫码支付" :visible.sync="dialogVisible" width="30%" append-to-body>
							<span style="text-align: center;display: block;"><img style="width: 340px;height: 340px;" :src="QRcode" /></span>
							<span style="text-align: center;display: block;margin-top: 10px;">扫码支付{{ ruleForm.money }}元</span>
							<span slot="footer" class="dialog-footer">
								<el-button @click="dialogVisible = false">取 消</el-button>
								<el-button @click="toOrder()">已支付</el-button>
							</span>
						</el-dialog>
						<!-- 输入金额表单 -->
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm1">
							<el-form-item label="支付金额" label-width="120px" prop="money">
								<el-input v-model="ruleForm.money" autocomplete="off" style="width: 400px;"></el-input>
							</el-form-item>
							<i class="el-icon-warning-outline" style="color: #ffaa00;margin-left: 120px;"></i>
							<span>温馨提示：具体订购价格，请咨询确认。</span>
						</el-form>
						<div slot="footer" class="dialog-footer">
							<el-button @click="outerVisible = false">取 消</el-button>
							<el-button type="primary" @click="toWechatPay()">去支付</el-button>
						</div>
					</el-dialog>
				</div>
			</el-main>
			<el-footer class="footer"><s-footer></s-footer></el-footer>
			<el-footer class="copy-right"><s-copyRight></s-copyRight></el-footer>
		</el-scrollbar>
	</el-container>
</template>

<script>
import sHeaderTop from '@/components/header_top';
import sHeader from '@/components/header';
import sFooter from '@/components/footer';
import sCopyRight from '@/components/copy-right';
import { productDetail, saveColl, collectionLight, cancelColl, buyProduct } from '@/api';
import store from '@/store/index.js';
export default {
	name: 'productDetail',
	components: {
		sHeaderTop,
		sHeader,
		sFooter,
		sCopyRight
	},
	data() {
		var validateMoney = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入金额'));
			} else if (!/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value)) {
				return callback(new Error('请输入正确的金额'));
			} else if (value < this.item.price) {
				return callback(new Error('不能低于起始价格'));
			} else {
				callback();
			}
		};
		return {
			id: '',
			item: null,
			isCollect: '',
			token: false,
			outerVisible: false, //输入价格dialog
			dialogVisible: false, //微信二维码支付dialog
			QRcode: '', //支付二维码
			orderId: '', //支付订单号
			ruleForm:{
				money: 0.00, //支付金额
			},
			rules: {
				money: [
					{ validator: validateMoney, trigger: 'blur' }
				],
			},
		};
	},
	mounted(option) {
		this.token = localStorage.getItem('token');
		(this.id = this.$route.query.id), //接受参数关键代码
			this.getPproductDetail(this.id);
		//如果当前是登录状态，默认进来已收藏的产品 修改收藏按钮图标
		if (store.state.isLogin) {
			this.collectionLight();
		}
	},
	methods: {
		//获取当前产品详情
		getPproductDetail(id) {
			let _this = this;
			productDetail({
				id: id
			}).then(res => {
				_this.item = res.data;
				_this.ruleForm.money = res.data.price;
			});
		},
		//点击定购弹出输入价格dialog，若未登录提醒先登录
		buy() {
			if (store.state.isLogin) {
				this.outerVisible = true;
			}else{
				this.$confirm('购买产品需要先登录, 是否登录?', '提示', {
				  confirmButtonText: '去登陆',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					this.toWxAuthorization()
				}).catch(() => {
				});
			}
		},
		//弹出微信支付 并请求展示二维码
		toWechatPay() {
			let _this = this;
			_this.$refs['ruleForm1'].validate((valid) => {
				if (valid) {
					_this.dialogVisible = true;
					buyProduct({
						cnts: 1,
						type: 'PC',
						productID: _this.id,
						money: _this.ruleForm.money
					}).then(res => {
						_this.QRcode = _this.$imgBaseUrl + res.data.imgUrl;
						_this.orderId = res.data.orderNo;
						// _this.dialogVisible = true;
					});
				}
			})
		},
		//支付完成，跳转至订单页面
		toOrder() {
			let routeUrl = this.$router.resolve({
				path: '/orderDetail', //跳转的路径
				query: {
					//路由传参时push和query搭配使用 ，作用时传递参数
					id: this.orderId
				}
			});
			window.open(routeUrl.href, '_blank');
		},
		//取消收藏
		cancelColl() {
			cancelColl({
				id: this.id,
				typeName: 'msg_product'
			}).then(res => {
				this.isCollect = !this.isCollect;
				this.$forceUpdate();
				this.$message({
					message: '取消成功',
					type: 'success'
				});
			});
		},
		//收藏
		collectionLight() {
			let _this = this;
			collectionLight({
				id: this.id,
				typeName: 'msg_product'
			}).then(res => {
				if (res.code == 1) {
					_this.isCollect = false;
				} else {
					_this.isCollect = true;
				}
			});
		},
		//收藏
		save() {
			saveColl({
				id: this.id,
				typeName: 'msg_product'
			}).then(res => {
				if (res.code == 0) {
					this.isCollect = !this.isCollect;
					this.$message({
						message: '收藏成功',
						type: 'success'
					});
				}
			});
		},
		//登录
		toWxAuthorization(){		
			window.location.href ="https://open.weixin.qq.com/connect/qrconnect?appid=wx8683c33354eeddb1&redirect_uri="+window.location.href+"&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect"
		},
		//打电话弹框
		call(title, phone) {
			this.$alert(phone ? phone : '暂未提供', title, {
				confirmButtonText: '确定',
				callback: action => {}
			});
		},
		//图片地址
		imgPath(oldPath) {
			return this.$imgBaseUrl + oldPath;
		}
	}
};
</script>

<style lang="scss" scoped>
.page_body {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.detail_info{
	display: flex;
	flex-direction: row;
}
.detail_info_image{
	width: 200px;
}
.detail_info_mark{
	flex: 1;
}
.detail_info_image,
.detail_info_mark {
	height: 200px;
}

.name {
	font-size: 20px;
}
.company {
	color: rgba(38, 124, 228, 1);
	display: flex;
	align-items: center;
}
.price {
	color: rgba(238, 52, 56, 1);
	font-weight: 600;
}
.company_before_tag {
	margin: 0 10px 0 0;
}
.company_name {
	font-size: 16px;
}
.buy,
.call,
.save {
	height: 36px;
	width: 100px;
	background-color: #f5f5f5;
	border: 1px solid #bbbbbb;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	margin-right: 30px;
	font-weight: 600;
	cursor: pointer;
}
.remark{
	width: 100%;
	>>> img{
		width:100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/product-detail.vue